export enum ContractTerminationReasonSystem {
None,
VoluntaryResignation,
}
